import popular from "./popular.png";
import topRated from "./top rated.png";
import upcoming from "./upcoming.png";

import action from "./action.png";
import adventure from "./adventure.png";
import animation from "./animation.png";
import comedy from "./comedy.png";
import crime from "./crime.png";
import documentary from "./documentary.png";
import drama from "./drama.png";
import family from "./family.png";
import fantasy from "./fantasy.png";
import history from "./history.png";
import horror from "./horror.png";
import music from "./music.png";
import mystery from "./mystery.png";
import romance from "./romance.png";
import science from "./science fiction.png";
import thriller from "./thriller.png";
import tv from "./tv movie.png";
import war from "./war.png";
import western from "./western.png";

export default {
  popular,
  "top rated": topRated,
  upcoming,
  action,
  adventure,
  animation,
  comedy,
  crime,
  documentary,
  drama,
  family,
  fantasy,
  history,
  horror,
  music,
  mystery,
  romance,
  "science fiction": science,
  thriller,
  "tv movie": tv,
  war,
  western,
};
